module.exports = __webpack_public_path__ + "img/banner_ms_case2.bc6e3766.png";